import cacheService from './cacheService';
import tokenManager from './tokenManager';

class CacheInitializer {
  constructor() {
    this.isInitialized = false;
    this.initPromise = null;
  }

  /**
   * Initialize essential caches that are needed on most pages
   */
  async initializeEssentialData() {
    if (this.isInitialized || this.initPromise) {
      return this.initPromise;
    }

  
    
    this.initPromise = this.loadEssentialData();
    await this.initPromise;
    this.isInitialized = true;
    
    return this.initPromise;
  }

  /**
   * Load essential data that's needed on most pages
   */
  async loadEssentialData() {
    try {
      // Load only essential data that's needed immediately
      const coreDataPromises = [
        cacheService.getAmenities().catch(err => {}),
        // Only load trending POIs instead of all POIs
        cacheService.getTrendingPOIs(1, 20).catch(err => {}),
        // Only load first page of public itineraries
        cacheService.getPublicItineraries({ page: 1, limit: 10 }).catch(err => {}),
      ];

      // Load navbar data (weather, exchange rates) - use cached data if available
      const navbarDataPromises = [
        cacheService.getWeather().catch(err => {}),
        cacheService.getExchangeRates().catch(err => {}),
      ];

      // Load all essential data in parallel
      await Promise.allSettled([...coreDataPromises, ...navbarDataPromises]);
      

    } catch (error) {

    }
  }

  /**
   * Initialize user-specific data (only call when user is authenticated)
   */
  async initializeUserData() {
    const token = tokenManager.getToken();
    if (!token) {

      return;
    }

    
    
    try {
      // Load only essential user data immediately (profile)
      // Favorites and trips will be loaded when user navigates to those screens
      const userDataPromises = [
        cacheService.getProfile().catch(err => {}),
      ];

      await Promise.allSettled(userDataPromises);
      
    } catch (error) {
      
    }
  }

  /**
   * Initialize all cache data (essential + user)
   */
  async initializeAllData() {
    await Promise.all([
      this.initializeEssentialData(),
      this.initializeUserData()
    ]);
  }

  /**
   * Reset initialization state (useful for logout)
   */
  reset() {
    this.isInitialized = false;
    this.initPromise = null;
  }

  /**
   * Get initialization status
   */
  getStatus() {
    return {
      isInitialized: this.isInitialized,
      isInitializing: !!this.initPromise && !this.isInitialized
    };
  }
}

// Export singleton instance
const cacheInitializer = new CacheInitializer();
export default cacheInitializer; 